import Vue from 'vue';
// Domain
import { RecommendedInvestmentProductStateManager } from '@/modules/flagship/investor-profile/recommended-investment-product/domain/state/recommended-investment-product-state-manager';
import RecommendedInvestmentProductState from '@/modules/flagship/investor-profile/recommended-investment-product/domain/state/recommended-investment-product-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class RecommendedProductVueStateManager
implements RecommendedInvestmentProductStateManager {
  // eslint-disable-next-line max-len
  private _state: RecommendedInvestmentProductState = Vue.observable<RecommendedInvestmentProductState>(new RecommendedInvestmentProductState());

  private readonly observers: Observer[] = [];

  get state(): RecommendedInvestmentProductState {
    return this._state;
  }

  set state(value: RecommendedInvestmentProductState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<RecommendedInvestmentProductState>) {
    type Keys = keyof RecommendedInvestmentProductState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
